const emptyEntity = {}

export default function selectEntity(entities, id) {
  if (!id) {
    return emptyEntity
  }

  return entities[id] || { id }
}



// WEBPACK FOOTER //
// ../src/selectors/selectEntity.js